@if(showProgressBar && lisOfProgressBarValue.length){
<h5 class="text-sm fw-500 mb-0 mb-3">Files</h5>

<ul class="list list-unstyled mb-0" [ngClass]="{ 'w-100': isContactUsForm }">
  @for(uploadProgress of lisOfProgressBarValue; track uploadProgress.uuid){
  <li
    class="d-flex flex-column gap-1 mb-3"
    [ngClass]="{
      'flex-md-row justify-content-md-between gap-md-4 align-items-md-center':
        !isContactUsForm
    }"
  >
    <div
      class="d-flex align-items-center gap-2"
      [ngClass]="{ 'file-name-container': isContactUsForm }"
    >
      <img width="24" height="24" src="images/Document.svg" alt="File" />

      <h5 [title]="uploadProgress.fileName" class="file-name text-sm mb-0">
        {{ uploadProgress.fileName }}&nbsp;({{ uploadProgress.fileSize }})
      </h5>
    </div>

    <div
      class="d-flex align-items-center justify-content-between"
      [ngClass]="{
        'justify-content-md-start': !isContactUsForm,
        'gap-3': isContactUsForm
      }"
    >
      <div
        class="d-flex align-items-center"
        [ngClass]="{ 'file-upload-progress-container': isContactUsForm }"
      >
        <mat-progress-bar
          [ngClass]="{
            'file-upload-progress-contact-us': isContactUsForm,
            'file-upload-progress': !isContactUsForm
          }"
          [value]="uploadProgress.value"
        ></mat-progress-bar>

        <span class="text-sm ms-2">{{ uploadProgress.value }}%</span>
      </div>

      <button
        title="Remove"
        type="button"
        class="button-no-style"
        [ngClass]="{ 'ms-4': !isContactUsForm }"
        (click)="onRemoveFile(uploadProgress.uuid)"
      >
        <img width="15" height="15" src="images/close.svg" alt="Remove" />
      </button>
    </div>
  </li>
  }
</ul>
}

<div
  dragDrop
  [ngStyle]="{ height: inputHeight || '10rem' }"
  class="upload cursor-pointer w-100"
  (fileDropped)="onFileSelected($event)"
>
  <label class="d-block w-100 h-100">
    <input
      #uploadInput
      type="file"
      [multiple]="isMultiple"
      [accept]="acceptFileMimes"
      (change)="onFileSelected($event)"
      hidden
    />
    <div class="upload__dropzone__content cursor-pointer">
      <div class="upload__dropzone__content__icon">
        <img width="47" height="46" src="images/upload-icon.svg" alt="Upload" />
      </div>
      <p
        class="upload_dropzone__content__text text__light-gray text-sm mb-0 text-center"
      >
        <span class="text-primary fw-600">Click to Browse</span> Or drag and
        drop
      </p>
      <span
        class="upload_dropzone__content__text text__light-gray text-sm mb-0 text-center"
      >
        {{ fileGuideMesg }}
      </span>
    </div>
  </label>
</div>
